import Axios from "axios";
import { getItemInLocalStorage } from "./localStorage";
import { getValidToken } from "./authService";
import { INFINIPATH, PORTAL } from "../constants/urlConstants";
const PORTAL_BASE_URL = process.env.REACT_APP_PORTAL_BASE_URL;
const INFINIPATH_BASE_URL = process.env.REACT_APP_INFINIPATH_BASE_URL;

const api = Axios.create({
  baseURL: PORTAL_BASE_URL,
});

api.interceptors.request.use(
  async (config) => {
    const token = await getValidToken();
    config.headers.Authorization = `Bearer ${token} custom`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptor for global error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const errorResponse = error.response;
    // Handle Bad Request (400) errors
    if ((errorResponse && errorResponse.status === 400 && errorResponse.data?.message?.includes("Bad request, user not found")) || errorResponse && errorResponse.status === 401 || ( errorResponse && errorResponse.status === 403)) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/";
    }

    return Promise.reject(errorResponse);
  }
);

/**
 * @description This call is prior checking the user while login, before sending the OTP to check the user is already registered or not, this does not require any token
 */
export const postCallForGetUser = <T>(url: string, payload: T, type: string = PORTAL) => {
  return Axios.post( (type == PORTAL ? PORTAL_BASE_URL: INFINIPATH_BASE_URL) + url, payload, {})
    .then((response) => response)
    .catch((error) => {
      return error.response;
    });
};

export const postCall = <T>(url: string, payload: T, type: string = PORTAL) => {
  const userId = getItemInLocalStorage("localId");
  return api
    .post((type == PORTAL ? PORTAL_BASE_URL: INFINIPATH_BASE_URL) + url, payload, {
      headers: {
        Authorization: `Bearer ${getItemInLocalStorage("idToken")}`,
        userid: typeof userId === "number" ? `'${userId}'` : userId,
      },
    })
    .then((response) => {
      if (response?.data?.message?.includes("User authorization has failed")) {
        signOut();
      }
      return response;
    })
    .catch((error) => {
      return error.response || error.data;
    });
};

export const putCall = <T>(url: string, payload: T, type: string = PORTAL) => {
  const userId = getItemInLocalStorage("localId");
  return api
    .put((type == PORTAL ? PORTAL_BASE_URL: INFINIPATH_BASE_URL) + url, payload, {
      headers: {
        Authorization: `Bearer ${getItemInLocalStorage("idToken")}`,
        userid: typeof userId === "number" ? `'${userId}'` : userId,
      },
    })
    .then((response) => {
      if (response?.data?.message?.includes("User authorization has failed")) {
        signOut();
      }
      return response;
    })
    .catch((error) => {
      return error.response;
    });
};

export const getCall = ( 
  url: string,
  signal?: AbortSignal,
  type: string = PORTAL
  ) => {
  const userId = getItemInLocalStorage("localId");
  return api
    .get((type == PORTAL ? PORTAL_BASE_URL: INFINIPATH_BASE_URL) + url, {
      headers: {
        Authorization: `Bearer ${getItemInLocalStorage("idToken")}`,
        userid: typeof userId === "number" ? `'${userId}'` : userId,
      },
    })
    .then((response) => {
      if (response?.data?.message?.includes("User authorization has failed")) {
        signOut();
      }
      return response;
    })
    .catch((error) => {
      return error.response;
    });
};

export const deleteCall = <T>(url: string, payload?: T, type: string = PORTAL) => {
  const userId = getItemInLocalStorage("localId");
  return api
    .delete((type == PORTAL ? PORTAL_BASE_URL: INFINIPATH_BASE_URL) + url, {
      headers: {
        Authorization: `Bearer ${getItemInLocalStorage("idToken")}`,
        userid: typeof userId === "number" ? `'${userId}'` : userId,
      },
      data: payload, // Include the payload in the data property
    })
    .then((response) => {
      if (response?.data?.message?.includes("User authorization has failed")) {
        signOut();
      }
      return response;
    })
    .catch((error) => {
      console.error("Error in deleteCall:", error);
      return error.response;
    });
};

export const getCallForFaceLogin = (url: string, type: string = PORTAL) => {
  return Axios.get((type == PORTAL ? PORTAL_BASE_URL: INFINIPATH_BASE_URL) + url, {})
    .then((response) => response)
    .catch((error) => {
      return error.response;
    });
};

/**
 * @description Function to sign out the user once the session expires
 */
const signOut = () => {
  alert("Session expired. Please login again.");
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = "/";
};

/**
 * @description This call is to get user details this does not require any token
 */
export const getCallWithoutAuth = (url: string, type: string = INFINIPATH) => {
  return Axios.get((type == PORTAL ? PORTAL_BASE_URL: INFINIPATH_BASE_URL) + url)
    .then((response) => response)
    .catch((error) => {
      return error.response;
    });
};


//infinipath
export const getCallHDBWithoutAuth = (url: string, type: string = INFINIPATH) => {

return Axios.get((type == PORTAL ? PORTAL_BASE_URL: INFINIPATH_BASE_URL) + url)
    .then((response) => response)
    .catch((error) => {
      return error.response;
    });
}

  export const getCallHDB = (url: string , type: string = INFINIPATH) => {
  const userId = getItemInLocalStorage("localId");
  return api
    .get((type == PORTAL ? PORTAL_BASE_URL: INFINIPATH_BASE_URL) + url, {
      headers: {
        Authorization: `Bearer ${getItemInLocalStorage("idToken")}`,
        userid: typeof userId === "number" ? `'${userId}'` : userId,
      },
    })
    .then((response) => {
      if (response?.data?.message?.includes("User authorization has failed")) {
        signOut();
      }
      return response;
    })
    .catch((error) => {
      return error.response;
    });
};


export const postCallWithoutAuth = (url: string, payload: unknown, type: string = PORTAL) => {
  return Axios.post((type == PORTAL ? PORTAL_BASE_URL: INFINIPATH_BASE_URL) + url, payload, {})
    .then((response) => response)
    .catch((error) => {
      return error.response;
    });
};


export const patchCall=(
  url: string,
  payload: unknown,
  type: string = PORTAL
) => {
  const userId = getItemInLocalStorage("localId");
  return api
    .patch((type == PORTAL ? PORTAL_BASE_URL: INFINIPATH_BASE_URL) + url, payload, {
      headers: {
        Authorization: `Bearer ${getItemInLocalStorage("idToken")} custom`,
        userid: typeof userId === "number" ? `'${userId}'` : userId,
      },
    })
    .then((response) => {
      if (response?.data?.message?.includes("User authorization has failed")) {
        signOut();
      }
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}
